/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useEffect, useContext } from 'react';
import Alert from 'react-s-alert';
import { Table, Progress } from 'reactstrap';
import moment from 'moment';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';

// service imports
import ChatService from '../../services/ChatService';
import ProviderService from '../../services/ProviderService';
import GeneralService from '../../services/GeneralService';

// local imports
import UserNotApproved from './UserNotApproved';
import Message from '../general/Message';
import ErrorBoundary from '../general/ErrorBoundary';
import ProviderNavbar from './ProviderNavbar';
import SelectedClient from './SelectedClient';
import Loading from '../../assets/UW_Horizontal_Logo_Full.png';

const ClientSubscriptionDetail = props => {

    // contexts
    const { theme, fontWeight, colors } = useContext(ThemeContext);
    const { user, setUser, selectedTimeZone, userApprovalStatus } = useContext(AuthContext);

    // states
    const [selectedClient, setSelectedClient] = useState();
    const [subscription, setSubscription] = useState({});
    const [sessions, setSessions] = useState([]);
    const [showSessionDetail, setShowSessionDetail] = useState(-1);
    const [isLoading, setIsLoading] = useState(true);

    // useEffects
    useEffect(() => {
        try {
            setIsLoading(true);
            // console.log("states", props.subscription);
            ProviderService.getClientSubscription(props.subscription.client._id, props.subscription._id).then(client => {
                // console.log("client", client);
                setSelectedClient({
                    clientId: {
                        profileImage: client.client.profileImage,
                        title: client.client.title,
                        firstName: client.client.firstName,
                        lastName: client.client.lastName,
                        email: client.client.email,
                        phone: client.client.phone,
                        gender: client.client.gender
                    }
                });
                setSubscription(client.clientSubscription);
                setSessions(client.client.sessionList);
                setIsLoading(false);
            })
        } catch (err) {
            setIsLoading(false);
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('At Provider ClientSubscriptionDetail useEffect2', 'Error in try catch block', err.stack);
        }
    }, []);

    // handle functions


    // function's return
    return (
        <div className='clientSubscriptionDetail'>
            {
                isLoading ? null :
                    <div>
                        <ErrorBoundary errorAt="At Provider ClientSubscriptionDetail SelectedClient">
                            <SelectedClient client={selectedClient} />
                        </ErrorBoundary>
                        {
                            userApprovalStatus ?
                                <div>
                                    <div className='mb-3'>
                                        <h2 className='my-auto' style={theme.subHeadingSemibold}>Subscription Details</h2>
                                        <hr />
                                        <Table borderless>
                                            <tbody>
                                                <tr>
                                                    <td style={{ width: '30%' }}>
                                                        <span style={{ fontWeight: fontWeight.medium }}>Subscription Plan</span>
                                                    </td>
                                                    <td>
                                                        <span>{subscription.clientSubscriptionPlan.name}</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span style={{ fontWeight: fontWeight.medium }}>Call Sessions</span>
                                                    </td>
                                                    <td className="d-flex">
                                                        {
                                                            subscription.isActive ?
                                                                <div>
                                                                    <Progress className="successProgress my-auto mr-2" value={(100 * subscription.serviceDetails.call.currentCycleUsage) / subscription.clientSubscriptionPlan.serviceDetails.call} />
                                                                    <span>{`${subscription.serviceDetails.call.currentCycleUsage}/${subscription.clientSubscriptionPlan.serviceDetails.call}`}</span>
                                                                </div>
                                                                :
                                                                <span>{subscription.clientSubscriptionPlan.serviceDetails.call}</span>
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span style={{ fontWeight: fontWeight.medium }}>Video Sessions</span>
                                                    </td>
                                                    <td className="d-flex">
                                                        {
                                                            subscription.isActive ?
                                                                <div>
                                                                    <Progress className="successProgress my-auto mr-2" value={(100 * subscription.serviceDetails.video.currentCycleUsage) / subscription.clientSubscriptionPlan.serviceDetails.video} />
                                                                    <span>{`${subscription.serviceDetails.video.currentCycleUsage}/${subscription.clientSubscriptionPlan.serviceDetails.video}`}</span>
                                                                </div>
                                                                :
                                                                <span>{subscription.clientSubscriptionPlan.serviceDetails.call}</span>
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span style={{ fontWeight: fontWeight.medium }}>Messaging</span>
                                                    </td>
                                                    <td className="d-flex">
                                                        <span>Unlimited</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span style={{ fontWeight: fontWeight.medium }}>Start Date</span>
                                                    </td>
                                                    <td>
                                                        {/* baki */}
                                                        <span>{moment.unix(subscription.currentCycleStartDate).format("MMM DD, dddd")}</span>
                                                    </td>
                                                </tr>
                                                {
                                                    subscription.isActive ? [
                                                        <tr key="1">
                                                            <td>
                                                                <span style={{ fontWeight: fontWeight.medium }}>Next Payment Date</span>
                                                            </td>
                                                            <td>
                                                                {/* baki */}
                                                                <span>{subscription.isCancelled ? "-" : moment.unix(subscription.nextPaymentDate).format("MMM DD, dddd")}</span>
                                                            </td>
                                                        </tr>,
                                                        <tr key="2">
                                                            <td>
                                                                <span style={{ fontWeight: fontWeight.medium }}>Days Passed</span>
                                                            </td>
                                                            <td className="d-flex">
                                                                <Progress className="successProgress my-auto mr-2" value={(100 * subscription.currentCycleDaysGone) / subscription.currentCycleTotalDays} />
                                                                <span>{`${subscription.currentCycleDaysGone}/${subscription.currentCycleTotalDays}`}</span>
                                                            </td>
                                                        </tr>
                                                    ] : null
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                    <div className='mb-3'>
                                        <h2 className='my-auto' style={theme.subHeadingSemibold}>Session History</h2>
                                        <hr />
                                        <div className="card mb-4">
                                            <div className="card-header d-flex">
                                                <label className="my-auto">Session History</label>
                                            </div>
                                            <div className="card-body py-0">
                                                <div className="table-responsive">
                                                    <Table className="table table-bordered mb-0" id="dataTable" width="100%" cellSpacing="0">
                                                        <thead>
                                                            <tr>
                                                                <th>Session Date</th>
                                                                <th>Session Type</th>
                                                                <th>Booked On</th>
                                                                <th align="center">Details</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                sessions.map((item, index) => (
                                                                    <tr key={index}>
                                                                        <td>{moment(item.date).format('MMM DD, YYYY')}</td>
                                                                        <td>{item.modeOfServiceSelected}</td>
                                                                        <td>{moment(item.createdAt).format('MMM DD, YYYY')}</td>
                                                                        <td align="center"><a style={{ color: "#384E73" }} href="#" onClick={() => setShowSessionDetail(index)}>View details</a></td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <UserNotApproved />
                        }
                    </div>
            }
        </div>
    )

}

export default ClientSubscriptionDetail;